import axios from 'axios';
import { message } from 'antd';
import { API_LANGUAGE, API_LANGUAGETYPE } from '../../../commons/api';
import localStorage from '../../../utils/localStorage';

export async function _getTranslationMasterData() {
  const siteId = localStorage.get('currentSite');
  const accessToken = localStorage.get('accessToken');
  let getLanguageType = {
    method: 'GET',
    url: `${API_LANGUAGETYPE.GET}?SiteId=${siteId}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  };
  return axios(getLanguageType)
    .then((response) => {
      return response.data;
    })
    .catch(function (e) {
      message.error(e.message || "An error occurred");
     
    });
}

export async function _getTranslationData() {
  const siteId = localStorage.get('currentSite');
  const accessToken = localStorage.get('accessToken');
  let getLanguageType = {
    method: 'GET',
    url: `${API_LANGUAGE.GET}?SiteId=${siteId}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  };
  return axios(getLanguageType)
    .then((response) => {
      return response.data;
    })
    .catch(function (e) {
      message.error(e.message || "An error occurred");
     
    });
}

export async function _getTransFromKeyword(keyword) {
  const siteId = localStorage.get('currentSite');
  const accessToken = localStorage.get('accessToken');
  let getLanguageType = {
    method: 'POST',
    url: `${API_LANGUAGE.GET_BY_KEYWORD}?SiteId=${siteId}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    },
    data: {
      keyword
    }
  };
  return axios(getLanguageType)
    .then((response) => {
      return response.data;
    })
    .catch(function (e) {
      message.error(e.message || "An error occurred");
     
    });
}

export async function tranlateAllData(Language) {
  const siteId = localStorage.get('currentSite');
  const accessToken = localStorage.get('accessToken');
  let getLanguageType = {
    method: 'POST',
    url: `${API_LANGUAGE.UpdateKeywordsByLanguage}?SiteId=${siteId}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    },
    data: {
      Language
    }
  };
  return axios(getLanguageType)
    .then((response) => {
      return response.data;
    })
    .catch(function (e) {
      message.error(e.message || "An error occurred");
     
    });
    
}

export async function _saveTranslation(saveObject, apiURL, method) {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let payload = {
    method: method,
    url: `${API_LANGUAGE.Language}/${apiURL}?SiteId=${siteId}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    },
    data: saveObject
  };
  return axios(payload)
    .then((response) => {
      if (response && response.data) {
        return response.data;
      }
    })
    .catch(function (e) {
      message.error(e.message || "An error occurred");
    });
}


export async function _saveLangTranslation(data) {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let payload = {
    method: "POST",
    url: `${API_LANGUAGETYPE.CREATE}?SiteId=${siteId}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    },
    data
  };
  return axios(payload)
    .then((response) => {
      if (response && response.data) {
        return response.data;
      }
    })
    .catch(function (e) {
      message.error(e.message || "An error occurred");
     
    });
}
export async function _getCurrentLanguages() {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let changePassword = {
    method: 'GET',
    url: `${API_LANGUAGE.LanguageList}?SiteId=${siteId}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  };
  return axios(changePassword)
    .then((response) => {
      return response.data;
    })
    .catch(function (e) {
      message.error(e.message || "An error occurred");
     
    });
}
export async function downloadApi  () {
  let accessToken = localStorage.get('accessToken');
  let siteId = localStorage.get('currentSite');

  let options = {
    method: 'GET',
    url: `${API_LANGUAGE.Download}?SiteId=${siteId}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    }
  };
  return axios(options)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
    });
}
